import { render, staticRenderFns } from "./UserInvite.vue?vue&type=template&id=652f823e&scoped=true"
import script from "./UserInvite.vue?vue&type=script&lang=js"
export * from "./UserInvite.vue?vue&type=script&lang=js"
import style0 from "./UserInvite.vue?vue&type=style&index=0&id=652f823e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f823e",
  null
  
)

export default component.exports